// extracted by mini-css-extract-plugin
export default {"chart":"styles_chart__KYInR","chartHeader":"styles_chartHeader__weJ6x","caption":"styles_caption__GlnKa","spin":"styles_spin__cL5BC"};